module.exports = __webpack_public_path__ + "static/img/case6.2a0ee4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case6.png
// module id = dwsO
// module chunks = 1